// extracted by mini-css-extract-plugin
module.exports = {"header":"header-1ZWTD","legNumber":"legNumber-2m6zW","title__text":"title__text-HGZT4","title__cities":"title__cities-ffMPP","diagram":"diagram-JzkLq"};